module.exports = __webpack_public_path__ + "static/img/ga.1aa26b2b.svg";